import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FEEDBACK_PATH, useOnFeedbackScreen } from './feedbackScreen';
import './FeedbackLink.css';

// A standing invitation to say what the product is worth, mounted next to each place the AI
// does its work (#234).
//
// The banner of #212 and the spent-allowance funnel of #208 both ask on an event; this asks
// nobody in particular, and waits. That is why it is a line of text and not a second banner:
// it can be on screen at the same moment as the banner without the pair reading as nagging.
function FeedbackLink() {
  const { t } = useTranslation();
  const onFeedbackScreen = useOnFeedbackScreen();

  if (onFeedbackScreen) {
    return null;
  }

  return (
    <div className="feedback-link">
      <Link to={FEEDBACK_PATH}>{t('feedbackLink.label')}</Link>
    </div>
  );
}

export default FeedbackLink;
